import { getNetwork } from "./lib/hooks/useNetwork";
const ROUTES = {
  deployer: "/",
  jetton: "/jetton",
  jettonId: "/jetton/:id",
  management: "/management",
};

const BANAN_TOOL = "UQAS6n3WZLGv89oGbQuu_5GW2eP7nWhr1CzUw7LuQdi1JZIf";
const CREATE_TOKEN_FEE = "5000000000";

const APP_GRID = 1156;

const LOCAL_STORAGE_PROVIDER = "wallet_provider";

const APP_DISPLAY_NAME = "BananaTool";

// Wallets fetch this file directly during the TON Connect handshake. Keep it
// on the canonical HTTPS domain instead of deriving it from a preview or
// redirected host name.
const TON_CONNECT_MANIFEST_URL = "https://ton.bananatool.org/tonconnect-manifest.json";

const JETTON_DEPLOYER_CONTRACTS_GITHUB = "https://t.me/BananaTools";

const EXAMPLE_ADDRESS =
  getNetwork(new URLSearchParams(window.location.search)) === "testnet"
    ? "EQBP4L9h4272Z0j_w9PE2tjHhi8OwkrRbTmatKszMyseis05"
    : "EQD-LkpmPTHhPW68cNfc7B83NcfE9JyGegXzAT8LetpQSRSm";

const SEARCH_HISTORY = "searchHistory";

export {
  ROUTES,
  LOCAL_STORAGE_PROVIDER,
  APP_GRID,
  JETTON_DEPLOYER_CONTRACTS_GITHUB,
  APP_DISPLAY_NAME,
  TON_CONNECT_MANIFEST_URL,
  EXAMPLE_ADDRESS,
  SEARCH_HISTORY,
  BANAN_TOOL,
  CREATE_TOKEN_FEE,
};
